import { Injectable } from '@angular/core';
import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import {
  Firestore,
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { appEnv } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAppService {
  private app: FirebaseApp;
  private firestore?: Firestore;

  constructor() {
    const existingApps = getApps();
    this.app = existingApps.length ? existingApps[0] : initializeApp(appEnv.firebaseConfig);
  }

  getApp(): FirebaseApp {
    return this.app;
  }

  /**
   * The one Firestore instance every messaging service shares. It keeps an
   * IndexedDB cache shared by all open admin tabs: one tab runs each listener
   * for every tab, and a reload within ~30 minutes only reads the documents
   * that changed instead of the whole result again (we're on the free plan's
   * 50k reads/day). Falls back to the default instance if Firestore was
   * already started without the cache.
   */
  getFirestore(): Firestore {
    if (!this.firestore) {
      try {
        this.firestore = initializeFirestore(this.app, {
          localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
        });
      } catch {
        this.firestore = getFirestore(this.app);
      }
    }
    return this.firestore;
  }
}
